<template>
  <div class="home">

    <h1> Welcome to our app </h1>
    <br>
    <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Obcaecati, nisi ullam dolores est commodi maiores perspiciatis deserunt, aliquam explicabo temporibus eum. Aut soluta sequi, praesentium ullam distinctio aliquam aspernatur magnam quibusdam ea. Similique, praesentium? Officiis commodi ad vitae porro dolore, doloribus, necessitatibus explicabo corrupti non placeat at reprehenderit delectus cumque temporibus repellendus, et consequuntur minus deleniti aliquid! Neque, molestiae ad.</p>

    <img src="../../public/images/web/hero.png" alt="hero" class="hero">

    <div class="options">
      <button @click="$router.push('register')"> Register </button>
      <button @click="$router.push('main-page')"> Login </button>
    </div>
    
  </div>
</template>

<script>

export default {
  components: {
    
  }
}
</script>

<style scoped>
  .hero {
    display: block;
    height: 350px;
    width: 100%;
    margin-top: 40px;
    opacity: 0.6;
    object-fit: contain;
  }
  .options {
    display: flex;
  }
  .options button {
    margin: 40px 20px 0;
  }
</style>
